module.exports = __webpack_public_path__ + "img/2.9e6a2a36.jpg";